import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { StrictNumberOnlyDirective } from '../utils/StrictNumbersOnlyDirective';
import { UsernameDirective } from '../utils/UserNameDirective';
import { FirstNameDirective } from '../utils/FirstNameDirective';
import { LastNameDirective } from '../utils/LastNameDirective';
import { MapComponent } from '../map/map.component';
import { ImageGridComponent } from '@app/image-grid/image-grid.component';
import { SpinnerComponent } from '@app/spinner/spinner.component';
import { NgxSpinnerModule } from "ngx-spinner";
@NgModule({
 imports:      [ CommonModule ,FormsModule,NgxSpinnerModule],
 declarations: [ StrictNumberOnlyDirective, FirstNameDirective, LastNameDirective, MapComponent,UsernameDirective,ImageGridComponent,SpinnerComponent],
 exports:      [ CommonModule,FormsModule,StrictNumberOnlyDirective,FirstNameDirective,LastNameDirective,MapComponent,UsernameDirective,ImageGridComponent,NgxSpinnerModule,SpinnerComponent],
})
export class SharedModule { }
